import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const USER_MAPPING_URL = `${BUSINESS_ADMIN_HOST}/v1/users/map`;
export const CREATE_USER_MAPPING_UPLOAD_URL = `${USER_MAPPING_URL}/upload/csv`;
